if (!customElements.get('hoculus-product-cta-sticky')) {
    class hoculusProductCtaSticky extends HTMLElement {
        static observedAttributes = ["variant-string"];

        constructor() {
            super();
        }

        connectedCallback() {
            const addToCartButtons = document.querySelectorAll("div.product-form_quantity button[type=submit]");
            const subscribeButtons = document.querySelectorAll("div.product-subscribe_form button[type='submit']");

            const observerOptions = {
                root: null,
                rootMargin: "0px",
            };

            const intersectionCallback = (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) { // Checks if at least one of the two buttons is visible to hide the cta
                        this.classList.remove("show-sticky");
                        break
                    } else {
                        this.classList.add("show-sticky");
                    }
                }
            }

            // Intersection observer to show the hoculus-product-cta-sticky when the add to button container is not visible
            const ctaObserver = new IntersectionObserver(intersectionCallback, observerOptions);
            ctaObserver.observe(addToCartButtons[0]);
            subscribeButtons[0] ? ctaObserver.observe(subscribeButtons[0]):"";
        }

        attributeChangedCallback(name, oldValue, newValue) {
            this.querySelector("span.product-variants").innerText = newValue;
        }
    }
    customElements.define("hoculus-product-cta-sticky", hoculusProductCtaSticky);
}